/**
 * Client UX copy for moment-description moderation.
 * The actual check runs on the server (`server/src/utils/momentTextModeration.ts`)
 * because `obscenity` uses modern JS that CRA 4 cannot transpile from node_modules.
 */

export const PROHIBITED_MOMENT_TEXT_MESSAGE = "Moment description contains prohibited language and cannot be saved or published.";

export function isProhibitedMomentTextError(messageText: string | null | undefined): boolean {
  const msg = String(messageText || "");
  return msg.includes("prohibited language");
}
